(function () {
  function initAnchorNav(root) {
    if (!root || root.dataset.lpAnInit === 'true') return;
    root.dataset.lpAnInit = 'true';

    var placeholder = root.previousElementSibling;
    if (!placeholder || !placeholder.hasAttribute('data-lp-an-placeholder')) {
      placeholder = document.createElement('div');
      placeholder.className = 'lp-anchor-nav__placeholder';
      placeholder.setAttribute('data-lp-an-placeholder', '');
      placeholder.setAttribute('aria-hidden', 'true');
      root.parentNode.insertBefore(placeholder, root);
    }

    var splideEl = root.querySelector('[data-lp-an-splide]');
    var toggle = root.querySelector('[data-lp-an-toggle]');
    var panel = root.querySelector('[data-lp-an-panel]');
    var toggleLabel = root.querySelector('[data-lp-an-toggle-label]');
    var desktopLinks = root.querySelectorAll('[data-lp-an-desktop-link]');
    var panelLinks = root.querySelectorAll('[data-lp-an-panel-link]');
    var mqDesktop = window.matchMedia('(min-width: 992px)');

    var splide = null;
    var sectionEntries = [];
    var scrollTicking = false;

    function getStickyTop() {
      var headerSection = document.querySelector('.shopify-section-header');
      if (!headerSection) return 0;

      if (document.body.classList.contains('shopify-body-section-header-hidden')) {
        return 0;
      }

      return Math.max(0, Math.round(headerSection.getBoundingClientRect().bottom));
    }

    function getScrollOffset() {
      return getStickyTop() + root.offsetHeight;
    }

    function buildSectionEntries() {
      var hrefMap = {};

      function registerLink(link) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#' || href.length < 2) return;

        if (!hrefMap[href]) {
          hrefMap[href] = {
            href: href,
            target: document.getElementById(href.slice(1)),
            desktopLink: null,
            panelLink: null
          };
        }

        if (link.hasAttribute('data-lp-an-desktop-link')) {
          hrefMap[href].desktopLink = link;
        }
        if (link.hasAttribute('data-lp-an-panel-link')) {
          hrefMap[href].panelLink = link;
        }
      }

      desktopLinks.forEach(registerLink);
      panelLinks.forEach(registerLink);

      sectionEntries = Object.keys(hrefMap)
        .map(function (key) {
          return hrefMap[key];
        })
        .filter(function (entry) {
          return entry.target;
        })
        .sort(function (a, b) {
          if (a.target === b.target) return 0;
          var position = a.target.compareDocumentPosition(b.target);
          if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
          if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
          return 0;
        });
    }

    function applyScrollMargins() {
      var margin = getScrollOffset() + 'px';
      sectionEntries.forEach(function (entry) {
        entry.target.style.scrollMarginTop = margin;
      });
    }

    function setActiveByHref(href) {
      if (!href) return;

      var activeDesktop = null;
      var activePanel = null;

      desktopLinks.forEach(function (el) {
        var isActive = el.getAttribute('href') === href;
        el.classList.toggle('is-active', isActive);
        if (isActive) activeDesktop = el;
      });

      panelLinks.forEach(function (el) {
        var isActive = el.getAttribute('href') === href;
        el.classList.toggle('is-active', isActive);
        if (isActive) activePanel = el;
      });

      var labelSource = activePanel || activeDesktop;
      if (toggleLabel && labelSource) {
        toggleLabel.textContent = labelSource.textContent.trim();
      }

      scrollSplideToActive(activeDesktop);
    }

    function setActiveLink(linkEl) {
      if (!linkEl) return;
      setActiveByHref(linkEl.getAttribute('href'));
    }

    function scrollSplideToActive(activeDesktop) {
      if (!splide || !mqDesktop.matches || !activeDesktop) return;

      var slide = activeDesktop.closest('.splide__slide');
      if (!slide || !slide.parentNode) return;

      var index = Array.prototype.indexOf.call(slide.parentNode.children, slide);
      if (index >= 0) splide.go(index);
    }

    function updateActiveFromScroll() {
      if (!sectionEntries.length) return;

      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var offset = getScrollOffset();
      var activeEntry = sectionEntries[0];

      sectionEntries.forEach(function (entry) {
        var sectionTop = entry.target.getBoundingClientRect().top + scrollTop;
        if (scrollTop + offset >= sectionTop - 4) {
          activeEntry = entry;
        }
      });

      setActiveByHref(activeEntry.href);
    }

    function updateSticky() {
      var stickyTop = getStickyTop();
      root.style.setProperty('--lp-an-sticky-top', stickyTop + 'px');

      var shouldStick = placeholder.getBoundingClientRect().top <= stickyTop;
      var isSticky = root.classList.contains('is-sticky');

      if (shouldStick !== isSticky) {
        root.classList.toggle('is-sticky', shouldStick);
      }

      placeholder.style.height = shouldStick ? root.offsetHeight + 'px' : '0';
      applyScrollMargins();
    }

    function onScrollOrResize() {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        updateSticky();
        updateActiveFromScroll();
        scrollTicking = false;
      });
    }

    function scrollToTarget(target) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function closePanel() {
      root.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    }

    function openPanel() {
      root.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
    }

    function bindLinkClicks(links, closeOnNavigate) {
      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var href = link.getAttribute('href');

          if (href && href.charAt(0) === '#' && href.length > 1) {
            var target = document.getElementById(href.slice(1));
            if (target) {
              event.preventDefault();
              scrollToTarget(target);
              setActiveLink(link);
              if (closeOnNavigate) closePanel();
              if (window.history && window.history.pushState) {
                window.history.pushState(null, '', href);
              } else {
                window.location.hash = href;
              }
              return;
            }
          }

          setActiveLink(link);
          if (closeOnNavigate) closePanel();
        });
      });
    }

    bindLinkClicks(desktopLinks, false);
    bindLinkClicks(panelLinks, true);

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        if (panel.hidden) {
          openPanel();
        } else {
          closePanel();
        }
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) closePanel();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closePanel();
      });
    }

    function updateOverflowState() {
      if (!splide || !splideEl || !mqDesktop.matches) return;

      var track = splideEl.querySelector('.splide__track');
      var list = splideEl.querySelector('.splide__list');
      if (!track || !list) return;

      requestAnimationFrame(function () {
        var overflows = list.scrollWidth > track.clientWidth + 2;

        splideEl.classList.toggle('lp-anchor-nav__desktop--static', !overflows);
        splide.options.drag = overflows;

        if (splide.Components && splide.Components.Drag && typeof splide.Components.Drag.disable === 'function') {
          splide.Components.Drag.disable(!overflows);
        }
        if (!overflows) {
          splide.go(0);
        }
      });
    }

    function mountSplide() {
      if (!splideEl || typeof Splide === 'undefined' || splide) return;
      splide = new Splide(splideEl, {
        type: 'slide',
        autoWidth: true,
        gap: 0,
        arrows: false,
        pagination: false,
        drag: true,
        wheel: false,
        trimSpace: true,
        focus: 0
      });
      splide.on('mounted resize updated', updateOverflowState);
      splide.mount();
      updateOverflowState();
      window.addEventListener('resize', updateOverflowState);
    }

    function destroySplide() {
      if (!splide) return;
      window.removeEventListener('resize', updateOverflowState);
      splide.destroy(true);
      splide = null;
      if (splideEl) splideEl.classList.remove('lp-anchor-nav__desktop--static');
    }

    function onMqChange() {
      if (mqDesktop.matches) {
        closePanel();
        mountSplide();
      } else {
        destroySplide();
      }
      onScrollOrResize();
    }

    buildSectionEntries();
    onMqChange();

    if (mqDesktop.addEventListener) {
      mqDesktop.addEventListener('change', onMqChange);
    } else {
      mqDesktop.addListener(onMqChange);
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    window.addEventListener('hashchange', function () {
      var hash = window.location.hash;
      if (!hash || hash.length < 2) return;

      var target = document.getElementById(hash.slice(1));
      if (!target) return;

      sectionEntries.some(function (entry) {
        if (entry.href === hash) {
          setActiveByHref(hash);
          return true;
        }
        return false;
      });
    });

    onScrollOrResize();

    if (window.location.hash) {
      window.setTimeout(onScrollOrResize, 120);
    }
  }

  function boot() {
    document.querySelectorAll('[data-lp-anchor-nav]').forEach(initAnchorNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lp-anchor-nav]');
    if (root) initAnchorNav(root);
  });
})();
